/**
 * One regulatory update in Home's Updates tab: the Regulatory page's status
 * circle, its title (receded once
 * reviewed), its jurisdiction and the day it was spotted.
 *
 * @module components/home/HomeUpdateRow
 */
import { Link } from "@tanstack/react-router";

import type { RegulatoryUpdate } from "../../state/policies";
import { publicationHash } from "../regulation/monitor/publicationLink";
import { StatusIcon } from "../regulation/monitor/linearGlyphs";
import { publicationState } from "../regulation/monitor/publications";
import { ListRow, ListRowDate, ListRowIcon, ListRowMeta, ListRowTitle } from "../ui/list-row";
import { Tip } from "../ui/tip";
import { pastDay } from "./homeDates.logic";
import { isUpdateToReview } from "./homeGlance.logic";
import { updateRowTooltip } from "./homeTabs.logic";

export function HomeUpdateRow({
  update,
  orgSegment,
  now,
}: {
  readonly update: RegulatoryUpdate;
  readonly orgSegment: string;
  readonly now: number;
}) {
  return (
    <Tip label={updateRowTooltip(update, now)}>
      <ListRow render={<Link to="/$org/compliance/regulatory" params={{ org: orgSegment }} hash={publicationHash(update.id)} />}>
        <ListRowIcon>
          <StatusIcon state={publicationState(update)} strokeWidth={1} />
        </ListRowIcon>
        <ListRowTitle ink={isUpdateToReview(update) ? "default" : "quiet"}>{update.title}</ListRowTitle>
        <ListRowMeta>{update.jurisdictionName}</ListRowMeta>
        <ListRowDate>{pastDay(Date.parse(update.detectedAt), now)}</ListRowDate>
      </ListRow>
    </Tip>
  );
}
